<template>
  <div class="container p-3 min-vh-100">
    <div
      class="flex-grow-1 d-flex flex-column gap-5 align-items-center justify-content-center"
    >
      <img
        :src="error ? getIcon('img/credit-line/error_warning_icon.svg') : icon"
        alt="icon"
        class="mt-5 w-25"
        :data-testid="error ? 'error-icon' : undefined"
      />

      <h1 class="fw-bold text-center text-black" v-html="title"></h1>

      <p class="fw-bold text-center text-black" v-html="description"></p>
      <p
        v-if="secondDescription"
        class="fw-bold text-center text-black"
        v-html="secondDescription"
      ></p>
      <span id="device-tag" v-if="showDeviceTag" class="text-center mt-3">{{
        t("PAYJOY_CARD_VIEWS.DEVICE_ID", { deviceTag: DeviceTag })
      }}</span>
    </div>

    <div class="floating-btn w-100" v-if="!customFooter">
      <Button id="btn-continue" class="text-start w-100" @click="goToHome()">
        <p class="text-center text-white fw-bold my-auto">
          {{ btnText }}
        </p>
      </Button>
    </div>
    <slot v-else class="floating-btn"></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import Button from "@/apps/credit-line/components/Button.vue";
import { AuthenticationHelper } from "@/apps/credit-line/helpers/authentication.helper";
import useAsset from "@/apps/credit-line/helpers/useAsset";
export default defineComponent({
  name: "VerificationResult",
  components: { Button },
  emits: ["dismissFunc"],
  methods: {
    getIcon(path: string): string {
      return useAsset(path);
    },
  },
  computed: {
    DeviceTag() {
      return AuthenticationHelper.getDeviceTag();
    },
  },
  props: {
    icon: String,
    title: String,
    description: String,
    secondDescription: String,
    btnText: String,
    error: Boolean,
    showDeviceTag: Boolean,
    customFooter: { type: Boolean, default: false },
  },
  setup(_, { emit }) {
    const { t } = useI18n();

    const goToHome = () => emit("dismissFunc");

    return {
      t,
      goToHome,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/constants";
$pj-color-red-opaque: rgba(222, 14, 14, 0.4);
.error-icon-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  color: $pj-color-white;
  width: 60px;
  height: 60px;
  border-radius: 30px;
  background-color: $pj-color-red;
  border: 5px solid $pj-color-red-opaque;
  -webkit-background-clip: padding-box; /* for Safari */
  background-clip: padding-box; /* for IE9+, Firefox 4+, Opera, Chrome */
  font-size: 40px;

  i {
    margin: 0;
  }
}
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  flex: 1 0 0;
}

#btn-gotohome {
  border-radius: 12px;
  height: 3rem;
  width: 100%;
  z-index: 500;
}

#btn-gotohome p {
  font-size: large;
}

.floating-btn {
  height: auto;
  padding: 1rem;
  left: 0;
  bottom: 0;
  z-index: 200;
}

#device-tag {
  color: var(--major-disable, #828282);
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19.6px; /* 140% */
  letter-spacing: 0.21px;
}
</style>
